module.exports = __webpack_public_path__ + "img/no-img.9615ff78.png";